import { render, staticRenderFns } from "./TwoFactorOptions.vue?vue&type=template&id=6ffe28b0&"
import script from "./TwoFactorOptions.vue?vue&type=script&lang=js&"
export * from "./TwoFactorOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports